export const SET_VEHICLES = '@ vehicles / SET_VEHICLES'

export const setVehicles = (payload) => (
    {
        type: SET_VEHICLES,
        payload,
    }
)
